import styled from "styled-components";

export const StatusCardRoot = styled.article`
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem;
    background-color: ${(props) => props.theme.palette.contractElementPanel};
    border-radius: 12px;
    box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    cursor: default;
    margin-top: 1em;
`;

export const StatusCardTitle = styled.h3`
    margin: 0;
    font-size: 18px;
    font-weight: 900;
    line-height: 1.3;
    text-align: left;
    overflow-wrap: anywhere;
    word-break: break-word;
`;

export const StatusCardBody = styled.div`
    min-width: 0;
`;

export const StatusPill = styled.div<{ $statusColor: string }>`
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    border-radius: 12px;
    border: 2px solid ${(props) => props.$statusColor === "transparent" ? "transparent" : props.$statusColor};
    background-color: ${(props) => props.$statusColor};
    text-align: center;
    padding: 0.35em 0.75em;
    overflow: hidden;
`;

export const StatusPillText = styled.p<{ $statusColor: string }>`
    margin: 0;
    color: ${(props) => props.$statusColor === "transparent" ? "#555555" : "white"};
    font-size: 16px;
    line-height: 1.3;
    overflow-wrap: anywhere;
    word-break: break-word;
    cursor: default;
`;